import { Input as AriaInput, type InputProps as AriaInputProps } from "react-aria-components";
import { tv, type VariantProps } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";

export type InputVariantProps = VariantProps<typeof inputStyles>;
export type Input2Sizes = InputVariantProps["size"];
export type Input2Props = Omit<AriaInputProps, "size"> & InputVariantProps;

export function Input2({ className, size, variant, ...props }: Input2Props) {
  const { input } = inputStyles({ size, variant });

  return (
    <AriaInput
      className={cn(input(), "atom-focus", className)}
      {...{ inert: variant === "readOnly" ? "" : undefined }}
      {...props}
    />
  );
}

const inputStyles = tv({
  defaultVariants: {
    size: "md",
    variant: "default",
  },
  slots: {
    input: cn(
      "input-label-placeholder",
      "tw:px-2.5 tw:py-2.5",
      "tw:rounded-sm! tw:bg-fill-white",
      "tw:border tw:border-solid",
      "tw:data-disabled:border-stroke-tertiary tw:data-disabled:bg-fill-senary",
      "tw:data-disabled:cursor-not-allowed tw:data-disabled:text-text-quinary",
      "tw:data-invalid:border-stroke-error-primary",
      "tw:focus:border-stroke-bright-purple-primary",
    ),
  },
  variants: {
    size: {
      lg: {
        input: "tw:h-12",
      },
      md: {
        input: "tw:h-11",
      },
      sm: {
        input: "tw:h-8",
      },
    },
    variant: {
      default: {
        input: "tw:border-stroke-tertiary tw:hover:border-stroke-secondary",
      },
      readOnly: {
        input: "tw:border-transparent tw:px-0 tw:pointer-events-none",
      },
    },
  },
});
